import { render, staticRenderFns } from "./CloneTemplateDialog.vue?vue&type=template&id=bbfd5c94&"
import script from "./CloneTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./CloneTemplateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CloneTemplateDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports